var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8243 4.02426C17.0586 3.78994 17.0586 3.41004 16.8243 3.17573C16.5899 2.94141 16.21 2.94141 15.9757 3.17573L9.99998 9.15147L4.0242 3.17573C3.78989 2.94142 3.40999 2.94142 3.17567 3.17574C2.94136 3.41005 2.94136 3.78995 3.17568 4.02427L9.15146 10L3.17573 15.9757C2.94142 16.21 2.94142 16.5899 3.17573 16.8243C3.41005 17.0586 3.78995 17.0586 4.02426 16.8243L9.99999 10.8485L15.9758 16.8243C16.2101 17.0586 16.59 17.0586 16.8243 16.8243C17.0586 16.5899 17.0586 16.21 16.8243 15.9757L10.8485 10L16.8243 4.02426Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0d0fe2108f9d1eda93bb6dee321efaf7.svg";
export { ForwardRef as ReactComponent };